import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components/Button';
import Icon from 'Components/Icon';

const TribunRouteModal = props => {

  return (
    <div className="play-coupon-success-modal">
      { props.onPrimaryButtonClick ? (
        <Button title={ 'KUPONLARIMA GİT' } className='btn--primary btn--half-round' onClick={ props.onPrimaryButtonClick }>
        KUPONLARIMA GİT
        </Button>
      ) : null }

      <Button title={ 'TRİBÜNE GİT' } className='btn--tribun btn--half-round' onClick={ props.onSecondaryButtonClick }>
        <div className="play-coupon-success-modal__button-content">
          <Icon iconName="svgTribunWhite" className="tribün-icon-ios-fix" />
          <span>TRİBÜNE GİT</span>
        </div>
      </Button>
    </div>
  );
};

TribunRouteModal.propTypes = {
  onPrimaryButtonClick: PropTypes.func,
  onSecondaryButtonClick: PropTypes.func,
  onlyBetSlip: PropTypes.bool
};

export default TribunRouteModal;